import { PageTitle } from './State'

export function Initial(): PageTitle {
  return {
    background: '',
    hidden: false,
  }
}
